import React from 'react';

function Mexico(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124045)">
        <mask
          id="mask0_800_124045"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124045)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.75 0H36V24H24.75V0Z"
            fill="#D9071E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H13.5V24H0V0Z"
            fill="#006923"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.25 0H24.75V24H11.25V0Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.6875 8.34179C14.5679 8.79695 14.6458 8.90439 15.2239 8.90439C15.2539 8.90439 15.3016 8.97982 15.3534 9.06188C15.4103 9.1519 15.4721 9.24989 15.5214 9.26503C15.5003 9.28986 15.2805 9.643 15.2794 10.265C15.2792 10.3931 15.3462 10.6042 15.4106 10.8069C15.4807 11.0275 15.5476 11.2381 15.5214 11.3213C15.4787 11.4569 15.2876 11.3092 15.1395 11.1948C15.0548 11.1293 14.9842 11.0747 14.9635 11.0902C14.8577 11.1693 14.8032 10.5432 14.7702 10.1649C14.7555 9.99641 14.7451 9.87709 14.7364 9.89102C14.6994 9.81867 14.6844 9.72978 14.6695 9.64196C14.6371 9.45098 14.6056 9.26503 14.352 9.26503H13.6995V9.69213C13.6995 9.69213 14.077 9.69213 14.077 10.4867C14.0833 10.6055 14.2595 11.6503 14.6875 11.6557C14.4367 11.6607 14.4386 11.7052 14.4397 11.7312L14.4398 11.7359C14.4398 12.3751 15.0407 12.4442 15.6024 12.2637C15.94 12.1553 16.2983 11.9436 16.5667 11.6826C16.9454 11.3144 16.9922 10.8376 16.4949 10.5762C16.3179 10.4831 16.1258 10.4471 15.8571 10.4338C15.9103 10.2937 15.86 10.1685 15.8208 10.0709C15.788 9.98922 15.7629 9.92681 15.8125 9.89102C16.3757 9.485 16.4259 9.11078 16.0161 8.77511C15.9629 8.73156 15.9115 8.67252 15.8585 8.61175L15.8585 8.61175C15.7587 8.49719 15.6535 8.37648 15.5214 8.34179C15.5824 8.23227 15.6647 8.09958 15.768 7.94671L14.8035 7.43195C14.6286 7.69081 14.6578 7.89328 14.6833 8.06973C14.6973 8.16658 14.7102 8.2556 14.6875 8.34179ZM14.6985 11.6555L14.6875 11.6557L14.6985 11.6555ZM14.6985 11.6555C14.7105 11.6553 14.7232 11.6552 14.7363 11.6552L14.7192 11.6551L14.6985 11.6555ZM15.7363 11.0079L15.7188 11.0246L15.7307 11.015C15.7325 11.0122 15.7344 11.0098 15.7363 11.0079ZM15.226 11.3213C15.2257 11.3214 15.2264 11.3213 15.2276 11.3211L15.2278 11.321L15.2386 11.3192C15.2342 11.3198 15.2301 11.3206 15.2278 11.321L15.226 11.3213Z"
            fill="#A8AC71"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.1819 7.91339C16.1819 7.91339 15.4093 8.44605 15.5538 9.01393C15.6983 9.58181 17.221 9.01393 17.0369 8.46366C16.8528 7.91339 16.1819 7.91339 16.1819 7.91339Z"
            fill="#FCCA3D"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.6748 12.4029C21.6748 12.4029 22.7154 9.66155 21.0612 8.24251C19.407 6.82347 17.4955 6.91843 17.4955 6.91843C17.4955 6.91843 16.9451 7.28197 17.4955 7.55923C18.046 7.83649 17.8154 8.10233 17.8154 8.10233C17.8154 8.10233 16.8935 7.27029 16.2815 7.7564C15.6696 8.24251 16.8528 8.16853 16.7276 8.53455C16.6023 8.90057 16.0716 10.5256 16.8471 11.3461C17.6225 12.1665 16.1139 11.9885 16.4207 11.9885C16.7276 11.9885 17.8154 12.1794 17.8154 11.9885C17.8154 11.7975 18.1936 12.7309 18.5172 12.7309C18.8409 12.7309 19.0907 12.4029 19.0907 12.4029C19.0907 12.4029 19.5444 12.7309 19.8208 12.7309C20.0972 12.7309 21.0612 12.5163 21.0612 12.5163L19.2393 11.1517C19.2393 11.1517 19.3491 10.5499 19.0907 10.4196C18.8322 10.2893 21.1627 11.574 21.3452 11.9885C21.5277 12.4029 21.6748 12.4029 21.6748 12.4029Z"
            fill="#8F4620"
          />
          <path
            d="M12.4497 11.7266C12.4497 11.7266 12.6186 11.248 12.7995 11.2148C12.9562 11.186 13.2856 11.4441 13.2856 11.4441C13.8709 14.334 15.2861 15.4627 17.6342 15.4627C20.01 15.4627 21.4499 14.6051 22.2902 11.9398C22.2902 11.9398 22.7369 11.5343 22.8945 11.5794C23.0661 11.6284 23.2811 12.1649 23.2811 12.1649C22.3171 15.2225 20.4958 16.5839 17.6342 16.5839C14.745 16.5839 13.1217 15.0448 12.4497 11.7266Z"
            fill="#9FAB2F"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.001 13.6564C15.001 13.6564 18.3809 14.2938 19.715 14.2938C21.049 14.2938 18.5444 15.2616 17.5672 15.2616C17.1397 15.2616 16.6244 15.0312 16.0214 14.5705C15.9133 14.488 16.018 14.3032 15.6887 14.3007C15.2296 14.2971 14.6593 14.2014 14.7138 14.1431C14.7657 14.0876 15.4337 14.0708 15.3693 14.0102C15.2631 13.9101 15.001 13.6564 15.001 13.6564Z"
            fill="#2FC2DC"
          />
          <rect
            x="16.5"
            y="14.1"
            width="2.25"
            height="1.07143"
            rx="0.166667"
            fill="#F9AA51"
          />
          <path
            d="M13.6973 12.1359C13.6973 12.1359 13.6973 11.7608 13.983 11.5616C14.3105 11.3331 14.6182 11.5616 14.6182 11.5616C15.8168 13.0802 17.6093 13.5798 20.1163 13.0584C20.1163 13.0584 20.8658 13.2761 20.9035 13.4191C20.9513 13.6007 20.3726 14.0321 20.3726 14.0321C17.442 14.6416 15.1766 14.0102 13.6973 12.1359Z"
            fill="#259485"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.6651 12.3503C18.6651 12.3503 17.2998 12.9891 17.7549 12.9891C18.21 12.9891 19.9912 13.3086 19.6446 12.9891C19.298 12.6697 18.6651 12.3503 18.6651 12.3503Z"
            fill="#FCCA3D"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.0509 11.5882C17.0509 11.5882 16.7915 10.9222 16.2516 10.9222C15.7117 10.9222 15.8641 11.4686 15.6045 11.4686C15.3449 11.4686 15.8464 11.853 16.0699 11.853C16.2935 11.853 17.0509 11.5882 17.0509 11.5882Z"
            fill="#FCCA3D"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124045">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Mexico;
